var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mts"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.09998 12.1C3.09998 16.05 5.24998 20 9.99998 20C14.75 20 16.9 16.05 16.9 12.1C16.9 9.4 16 6.3 14.55 3.85C13.15 1.45 11.45 0 9.99998 0C8.54998 0 6.84998 1.45 5.44998 3.85C3.99998 6.35 3.09998 9.45 3.09998 12.1Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMts);
export default __webpack_public_path__ + "static/media/mts.4fda6d7c415110f0d0d437ed70063c09.svg";
export { ForwardRef as ReactComponent };